import { MDXRemote, type MDXRemoteSerializeResult } from 'next-mdx-remote';
import { FC } from 'react';
import components from './components';

interface MDXcontainerProps {
  mdxSource: MDXRemoteSerializeResult<Record<string, unknown>>;
}

const MDXcontainer: FC<MDXcontainerProps> = ({ mdxSource }) => (
  <MDXRemote
    components={components}
    lazy
    {...mdxSource}
  />
);

export default MDXcontainer;
